export enum BdDunningChargeValutaDateTiming {
    DUNNING_START,
    DUNNING_STEP_START,
    TODAY
}
